import Header from '../components/Header';
import BackNavBar from '../components/BackNavBar';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPurchaseCart } from '../store/purchaseSlice';
import { fetchUserInfo } from '../store/authSlice';

function Field({ label, value }: { label: string; value?: string }) {
  return (
    <div>
      <p className="text-[10px] text-gray-400 font-dmsans mb-0.5">{label}</p>
      <p className="text-[13px] font-medium text-gray-900 font-dmsans">
        {value || '—'}
      </p>
    </div>
  );
}

export default function AccountDetails() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);
  const auth_token = useSelector((state: RootState) => state.auth.token);
  const { routesPrefix } = useSelector((state: RootState) => state.setup);

  useEffect(() => {
    if (auth_token) {
      dispatch(fetchPurchaseCart());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth_token]);

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, [dispatch]);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <BackNavBar
        label="Back to Storefront"
        onClick={() => navigate(routesPrefix)}
      />

      <div className="bg-secondary-50 min-h-screen">
        <div className="px-4 py-6 max-w-[560px] m-auto">
          <h1 className="font-bold text-[18px] font-dmsans text-gray-900 mb-5">
            Account Details
          </h1>

          <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div className="p-5">
              {/* Name + Email */}
              <div className="flex items-start divide-x divide-gray-200 mb-5">
                <div className="pr-4 flex-1 min-w-0">
                  <Field
                    label="Name"
                    value={
                      user?.firstName
                        ? `${user.firstName} ${user.lastName ?? ''}`.trim()
                        : undefined
                    }
                  />
                </div>
                <div className="pl-4 flex-1 min-w-0">
                  <Field label="Email" value={user?.email} />
                </div>
              </div>

              <hr className="border-gray-100 mb-5" />

              {/* Phone + Address */}
              <div className="flex items-start divide-x divide-gray-200">
                <div className="pr-4">
                  <Field label="Phone Number" value={user?.phoneNumber} />
                </div>
                <div className="pl-4 flex-1 min-w-0">
                  <Field label="Address" value={user?.customerAddress?.[0]} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
